'use client';

import { useEffect, useRef } from 'react';
import { useParams, useRouter } from 'next/navigation';
import useSdk from 'helpers/hooks/useSdk';
import { useCart } from 'frontastic';

interface ReservationGateProps {
  onSuccess: () => void;
}

const ReservationGate = ({ onSuccess }: ReservationGateProps) => {
  const sdk = useSdk();
  const { data } = useCart();
  const router = useRouter();
  const { locale } = useParams();
  const reservationChecked = useRef(false);

  useEffect(() => {
    if (data?.cartId) {
      if (reservationChecked.current) return;
      reservationChecked.current = true;
      sdk
        .callAction<{ statusCode: number }>({
          actionName: 'reservations/postReservations',
          payload: { cartId: data.cartId },
        })
        .then((res) => {
          if (!res || res.isError || !res.data?.statusCode || res.data.statusCode < 200 || res.data.statusCode > 299) {
            router.replace(`/${locale}/cart/?error=reservationFailed`);
          } else {
            onSuccess();
          }
        });
    }
  }, [data?.cartId, sdk, onSuccess, router, locale]);

  return (
    <div className="flex h-[80vh] items-center justify-center">
      <div className="loading-full-screen" />
    </div>
  );
};

export default ReservationGate;
